/* eslint-disable */
const colorsList = [
  {
    value: 'Black',
    color: 'Black'
  },
  {
    value: 'Black (FT)/Black-Blond (Herringbone)',
    color: 'Black'
  },
  {
    value: 'Black Denim',
    color: 'Black'
  },
  {
    value: 'Black Fish',
    color: 'Black'
  },
  {
    value: 'Black Frog',
    color: 'Black'
  },
  {
    value: 'Black Gabardine',
    color: 'Black'
  },
  {
    value: 'Black Heather',
    color: 'Black'
  },
  {
    value: 'Black Logo',
    color: 'Black'
  },
  {
    value: 'Black Plaid',
    color: 'Black'
  },
  {
    value: 'Black Ram',
    color: 'Black'
  },
  {
    value: 'Black Starfish',
    color: 'Black'
  },
  {
    value: 'Black w/Trim',
    color: 'Black'
  },
  {
    value: 'Black/Blond',
    color: 'Black'
  },
  {
    value: 'Black/Blond Herringbone',
    color: 'Black'
  },
  {
    value: 'Black/Blond Twill',
    color: 'Black'
  },
  {
    value: 'Black/Charcoal',
    color: 'Black'
  },
  {
    value: 'Black/Grey Heather',
    color: 'Black'
  },
  {
    value: 'Black/Grey Windowpane Check',
    color: 'Black'
  },
  {
    value: 'Black/Grey/Red',
    color: 'Black'
  },
  {
    value: 'Black/Herringbone Trim',
    color: 'Black'
  },
  {
    value: 'Black/Ivory',
    color: 'Black'
  },
  {
    value: 'Black/Lead',
    color: 'Black'
  },
  {
    value: 'Black/Midnight Blue/Charcoal',
    color: 'Black'
  },
  {
    value: 'Black/Midnight Herringbone',
    color: 'Black'
  },
  {
    value: 'Black/Natural',
    color: 'Black'
  },
  {
    value: 'Black/Pewter',
    color: 'Black'
  },
  {
    value: 'Black/Pewter/Charcoal',
    color: 'Black'
  },
  {
    value: 'Black/Rock Salt',
    color: 'Black'
  },
  {
    value: 'Black/Smoky Lilac',
    color: 'Black'
  },
  {
    value: 'Black/White',
    color: 'Black'
  },
  {
    value: 'Black/White Plaid',
    color: 'Black'
  },
  {
    value: 'Black/White Stripe',
    color: 'Black'
  },
  {
    value: 'Black/White Twill',
    color: 'Black'
  },
  {
    value: 'Gabardine: Black',
    color: 'Black'
  },
  {
    value: 'Herringbone Black/White',
    color: 'Black'
  },
  {
    value: 'Herringbone: Black/Midnight Blue',
    color: 'Black'
  },
  {
    value: 'Blue',
    color: 'Blue'
  },
  {
    value: 'Blue Check',
    color: 'Blue'
  },
  {
    value: 'Blue Denim',
    color: 'Blue'
  },
  {
    value: 'Blue Denim/Blond',
    color: 'Blue'
  },
  {
    value: 'Blue Denim/Yellow Plaid',
    color: 'Blue'
  },
  {
    value: 'Blue Green Multi',
    color: 'Blue'
  },
  {
    value: 'Blue Grey',
    color: 'Blue'
  },
  {
    value: 'Blue Herringbone',
    color: 'Blue'
  },
  {
    value: 'Blue Jay',
    color: 'Blue'
  },
  {
    value: 'Blue Jay/Royal Red',
    color: 'Blue'
  },
  {
    value: 'Blue Jay/Sky Blue',
    color: 'Blue'
  },
  {
    value: 'Blue Oxford',
    color: 'Blue'
  },
  {
    value: 'Blue Oxford 4 Assorted',
    color: 'Blue'
  },
  {
    value: 'Blue Oxford/Golden Rod',
    color: 'Blue'
  },
  {
    value: 'Blue Oxford/Royal Red',
    color: 'Blue'
  },
  {
    value: 'Blue Oxford/White',
    color: 'Blue'
  },
  {
    value: 'Blue Oxford/Wild Rose',
    color: 'Blue'
  },
  {
    value: 'Blue Plaid',
    color: 'Blue'
  },
  {
    value: 'Blue Regatta',
    color: 'Blue'
  },
  {
    value: 'Blue Tie Dye',
    color: 'Blue'
  },
  {
    value: 'Blue/Brown',
    color: 'Blue'
  },
  {
    value: 'Blue/Orange',
    color: 'Blue'
  },
  {
    value: 'Blue/Red Combo',
    color: 'Blue'
  },
  {
    value: 'Blue/Red Windowpane Check',
    color: 'Blue'
  },
  {
    value: 'Blue/Rust',
    color: 'Blue'
  },
  {
    value: 'Blue/White',
    color: 'Blue'
  },
  {
    value: 'Blue/White Check',
    color: 'Blue'
  },
  {
    value: 'Blue/White Stripe',
    color: 'Blue'
  },
  {
    value: 'Blue/White Stripe',
    color: 'Blue'
  },
  {
    value: 'Deep Navy',
    color: 'Blue'
  },
  {
    value: 'Denim',
    color: 'Blue'
  },
  {
    value: 'Denim Window Pane',
    color: 'Blue'
  },
  {
    value: 'Indigo',
    color: 'Blue'
  },
  {
    value: 'Indigo Dots',
    color: 'Blue'
  },
  {
    value: 'Indigo Novelty Dye',
    color: 'Blue'
  },
  {
    value: 'Indigo/Dune',
    color: 'Blue'
  },
  {
    value: 'Light Blue Dot',
    color: 'Blue'
  },
  {
    value: 'Light Blue Plaid',
    color: 'Blue'
  },
  {
    value: 'Medium Indigo',
    color: 'Blue'
  },
  {
    value: 'Midnight',
    color: 'Blue'
  },
  {
    value: 'Midnight Blue',
    color: 'Blue'
  },
  {
    value: 'Midnight Blue (FT)/Midnight-Black (Herringbone)',
    color: 'Blue'
  },
  {
    value: 'Midnight Blue/Herringbone Trim',
    color: 'Blue'
  },
  {
    value: 'Midnight Blue/Royal Red',
    color: 'Blue'
  },
  {
    value: 'Midnight Blue/Taupe',
    color: 'Blue'
  },
  {
    value: 'Midnight/Rock Salt',
    color: 'Blue'
  },
  {
    value: 'Misty Blue',
    color: 'Blue'
  },
  {
    value: 'Misty Blue Ram',
    color: 'Blue'
  },
  {
    value: 'Navy',
    color: 'Blue'
  },
  {
    value: 'Navy Fish',
    color: 'Blue'
  },
  {
    value: 'Navy Frog',
    color: 'Blue'
  },
  {
    value: 'Navy Plaid',
    color: 'Blue'
  },
  {
    value: 'Navy Starfish',
    color: 'Blue'
  },
  {
    value: 'Navy Stripe',
    color: 'Blue'
  },
  {
    value: 'Navy/Brown Tattersall',
    color: 'Blue'
  },
  {
    value: 'Navy/Light Blue Check',
    color: 'Blue'
  },
  {
    value: 'Navy/Magenta',
    color: 'Blue'
  },
  {
    value: 'Navy/Red Plaid',
    color: 'Blue'
  },
  {
    value: 'Navy/White/Green',
    color: 'Blue'
  },
  {
    value: 'New Blue',
    color: 'Blue'
  },
  {
    value: 'New Blue/Rock Salt',
    color: 'Blue'
  },
  {
    value: 'New Blue/Taupe',
    color: 'Blue'
  },
  {
    value: 'Ocean',
    color: 'Blue'
  },
  {
    value: 'Ocean Blues',
    color: 'Blue'
  },
  {
    value: 'Sail Navy',
    color: 'Blue'
  },
  {
    value: 'Sail Navy Logo',
    color: 'Blue'
  },
  {
    value: 'Sail Navy Ram',
    color: 'Blue'
  },
  {
    value: 'Sail Navy/Lead/Plum',
    color: 'Blue'
  },
  {
    value: 'Sail Navy/Rock Salt',
    color: 'Blue'
  },
  {
    value: 'Sail Navy/White',
    color: 'Blue'
  },
  {
    value: 'Sapphire',
    color: 'Blue'
  },
  {
    value: 'Sky Blue',
    color: 'Blue'
  },
  {
    value: 'Slate Blue',
    color: 'Blue'
  },
  {
    value: 'Slate Blue/Soft Gray/Spring Yellow',
    color: 'Blue'
  },
  {
    value: 'Teal',
    color: 'Blue'
  },
  {
    value: 'Teal/Orange Plaid',
    color: 'Blue'
  },
  {
    value: 'Tin',
    color: 'Blue'
  },
  {
    value: 'Bronze',
    color: 'Brown'
  },
  {
    value: 'Brown',
    color: 'Brown'
  },
  {
    value: 'Brown Blue Window Pane',
    color: 'Brown'
  },
  {
    value: 'Brown Heather',
    color: 'Brown'
  },
  {
    value: 'Brown Plaid',
    color: 'Brown'
  },
  {
    value: 'Brown w/ Grey Dot',
    color: 'Brown'
  },
  {
    value: 'Brown/Black',
    color: 'Brown'
  },
  {
    value: 'Brown/Green/Orange',
    color: 'Brown'
  },
  {
    value: 'Brown/Natural Plaid',
    color: 'Brown'
  },
  {
    value: 'Brown/Tan',
    color: 'Brown'
  },
  {
    value: 'Chestnut',
    color: 'Brown'
  },
  {
    value: 'Chocolate Brown',
    color: 'Brown'
  },
  {
    value: 'Chocolate/Blue/Tan Check',
    color: 'Brown'
  },
  {
    value: 'Clay',
    color: 'Brown'
  },
  {
    value: 'Cocoa',
    color: 'Brown'
  },
  {
    value: 'Copper',
    color: 'Brown'
  },
  {
    value: 'Cream/Brown Check',
    color: 'Brown'
  },
  {
    value: 'Ebony',
    color: 'Brown'
  },
  {
    value: 'Espresso',
    color: 'Brown'
  },
  {
    value: 'Espresso Marl',
    color: 'Brown'
  },
  {
    value: 'Espresso/Black',
    color: 'Brown'
  },
  {
    value: 'Espresso/Tan',
    color: 'Brown'
  },
  {
    value: 'Golden Brown Multi',
    color: 'Brown'
  },
  {
    value: 'Golden Brown Multi',
    color: 'Brown'
  },
  {
    value: 'Herringbone Brown',
    color: 'Brown'
  },
  {
    value: 'Honey/Molasses',
    color: 'Brown'
  },
  {
    value: 'Mocha',
    color: 'Brown'
  },
  {
    value: 'Oatmeal',
    color: 'Brown'
  },
  {
    value: 'Big Green',
    color: 'Green'
  },
  {
    value: 'Big Green/Blond',
    color: 'Green'
  },
  {
    value: 'Chartreuse',
    color: 'Green'
  },
  {
    value: 'Emerald',
    color: 'Green'
  },
  {
    value: 'Foliage',
    color: 'Green'
  },
  {
    value: 'Forest Green',
    color: 'Green'
  },
  {
    value: 'Green',
    color: 'Green'
  },
  {
    value: 'Green Blue Check',
    color: 'Green'
  },
  {
    value: 'Green Blue Window Pane',
    color: 'Green'
  },
  {
    value: 'Green Copper',
    color: 'Green'
  },
  {
    value: 'Green/Yellow Plaid',
    color: 'Green'
  },
  {
    value: 'Harvest Green',
    color: 'Green'
  },
  {
    value: 'Hunter Green',
    color: 'Green'
  },
  {
    value: 'Loden Green',
    color: 'Green'
  },
  {
    value: 'Military Green',
    color: 'Green'
  },
  {
    value: 'Moss Green',
    color: 'Green'
  },
  {
    value: 'New Leaf',
    color: 'Green'
  },
  {
    value: 'Olive',
    color: 'Green'
  },
  {
    value: 'Olive Blue',
    color: 'Green'
  },
  {
    value: 'Olive Marl',
    color: 'Green'
  },
  {
    value: 'Olive/Camel',
    color: 'Green'
  },
  {
    value: 'Olive/Red Check',
    color: 'Green'
  },
  {
    value: 'Pino Green',
    color: 'Green'
  },
  {
    value: 'Pino Green',
    color: 'Green'
  },
  {
    value: 'Sage',
    color: 'Green'
  },
  {
    value: 'Sage Logo',
    color: 'Green'
  },
  {
    value: 'Sage Ram',
    color: 'Green'
  },
  {
    value: 'Sage/Taupe',
    color: 'Green'
  },
  {
    value: 'Sage/White',
    color: 'Green'
  },
  {
    value: 'Vils Green',
    color: 'Green'
  },
  {
    value: 'Charcoal',
    color: 'Grey'
  },
  {
    value: 'Charcoal 4 Assorted',
    color: 'Grey'
  },
  {
    value: 'Charcoal 4 Pack',
    color: 'Grey'
  },
  {
    value: 'Charcoal Plaid',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Black',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Blond',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Madder Red',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Midnight Blue',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Midnight Blue',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Pewter',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Rock Salt',
    color: 'Grey'
  },
  {
    value: 'Charcoal/Sage',
    color: 'Grey'
  },
  {
    value: 'Charcoal/White',
    color: 'Grey'
  },
  {
    value: 'Dark Grey',
    color: 'Grey'
  },
  {
    value: 'Denim Grey',
    color: 'Grey'
  },
  {
    value: 'Gabardine: Chambray',
    color: 'Grey'
  },
  {
    value: 'Gingham Red/Grey',
    color: 'Grey'
  },
  {
    value: 'Granite Gray 4 Assorted',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Black',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Goldenrod',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Midnight Blue',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Pistachio',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Plum',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Rock Salt',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Royal Red',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/White',
    color: 'Grey'
  },
  {
    value: 'Granite Gray/Wild Rose',
    color: 'Grey'
  },
  {
    value: 'Graphite',
    color: 'Grey'
  },
  {
    value: 'Grey',
    color: 'Grey'
  },
  {
    value: 'Grey',
    color: 'Grey'
  },
  {
    value: 'Grey Check',
    color: 'Grey'
  },
  {
    value: 'Grey Heather',
    color: 'Grey'
  },
  {
    value: 'Grey Heather Stripe',
    color: 'Grey'
  },
  {
    value: 'Grey Heather/Grey Stripe',
    color: 'Grey'
  },
  {
    value: 'Grey Oxford',
    color: 'Grey'
  },
  {
    value: 'Grey Purple',
    color: 'Grey'
  },
  {
    value: 'Grey Stripe',
    color: 'Grey'
  },
  {
    value: 'Grey Stripe',
    color: 'Grey'
  },
  {
    value: 'Grey Stripe/Grey Heather',
    color: 'Grey'
  },
  {
    value: 'Grey with Blue',
    color: 'Grey'
  },
  {
    value: 'Grey with Brown',
    color: 'Grey'
  },
  {
    value: 'Grey with Dark Grey',
    color: 'Grey'
  },
  {
    value: 'Grey/Black',
    color: 'Grey'
  },
  {
    value: 'Grey/Blue',
    color: 'Grey'
  },
  {
    value: 'Grey/Brown',
    color: 'Grey'
  },
  {
    value: 'Grey/Brown Windowpane',
    color: 'Grey'
  },
  {
    value: 'Grey/Chocolate Small Check',
    color: 'Grey'
  },
  {
    value: 'Grey/Chocolate Windowpane Check',
    color: 'Grey'
  },
  {
    value: 'Grey/Grey',
    color: 'Grey'
  },
  {
    value: 'Grey/Navy/White',
    color: 'Grey'
  },
  {
    value: 'Grey/Red',
    color: 'Grey'
  },
  {
    value: 'Grey/White',
    color: 'Grey'
  },
  {
    value: 'Lead',
    color: 'Grey'
  },
  {
    value: 'Lead Marl',
    color: 'Grey'
  },
  {
    value: 'Lead/Grey Stripe',
    color: 'Grey'
  },
  {
    value: 'Lead/Tan',
    color: 'Grey'
  },
  {
    value: 'Light Grey',
    color: 'Grey'
  },
  {
    value: 'Light Grey Plaid',
    color: 'Grey'
  },
  {
    value: 'Nickel',
    color: 'Grey'
  },
  {
    value: 'Onyx',
    color: 'Grey'
  },
  {
    value: 'Onyx Marl',
    color: 'Grey'
  },
  {
    value: 'Pearl Grey',
    color: 'Grey'
  },
  {
    value: 'Pewter',
    color: 'Grey'
  },
  {
    value: 'Pewter/Black',
    color: 'Grey'
  },
  {
    value: 'Rock Salt',
    color: 'Grey'
  },
  {
    value: 'Rock Salt Logo',
    color: 'Grey'
  },
  {
    value: 'Rock Salt Ram',
    color: 'Grey'
  },
  {
    value: 'Rock Salt/Midnight Blue',
    color: 'Grey'
  },
  {
    value: 'Rock Salt/Pewter',
    color: 'Grey'
  },
  {
    value: 'Rock Salt-Black',
    color: 'Grey'
  },
  {
    value: 'Sail Navy/Soft Grey',
    color: 'Grey'
  },
  {
    value: 'Slate',
    color: 'Grey'
  },
  {
    value: 'Soft Grey',
    color: 'Grey'
  },
  {
    value: 'Stone',
    color: 'Grey'
  },
  {
    value: 'Multi-Color',
    color: 'Multi'
  },
  {
    value: 'Multicolor Jersey',
    color: 'Multi'
  },
  {
    value: 'Orange/Olive/Red/White Multi Check',
    color: 'Multi'
  },
  {
    value: 'Red Black Check w/ White',
    color: 'Multi'
  },
  {
    value: 'Salt/Pistachio/Coral',
    color: 'Multi'
  },
  {
    value: 'Burnt Orange',
    color: 'Orange'
  },
  {
    value: 'Orange',
    color: 'Orange'
  },
  {
    value: 'Coral',
    color: 'Pink'
  },
  {
    value: 'Coral Ram',
    color: 'Pink'
  },
  {
    value: 'Coral/Petal',
    color: 'Pink'
  },
  {
    value: 'Pink Ivory Check',
    color: 'Pink'
  },
  {
    value: 'Rose Petal',
    color: 'Pink'
  },
  {
    value: 'Salmon',
    color: 'Pink'
  },
  {
    value: 'Smoky Lilac',
    color: 'Pink'
  },
  {
    value: 'Wild Rose',
    color: 'Pink'
  },
  {
    value: 'Wild Rose/Espresso',
    color: 'Pink'
  },
  {
    value: 'Wild Rose/White',
    color: 'Pink'
  },
  {
    value: 'Amethyst',
    color: 'Purple'
  },
  {
    value: 'Azalea',
    color: 'Purple'
  },
  {
    value: 'Eggplant',
    color: 'Purple'
  },
  {
    value: 'Plum',
    color: 'Purple'
  },
  {
    value: 'Plum Plaid',
    color: 'Purple'
  },
  {
    value: 'Plum/Wild Rose',
    color: 'Purple'
  },
  {
    value: 'Purple',
    color: 'Purple'
  },
  {
    value: 'Violet',
    color: 'Purple'
  },
  {
    value: 'Brick',
    color: 'Red'
  },
  {
    value: 'Burgundy Herringbone',
    color: 'Red'
  },
  {
    value: 'Burgundy Tan Check',
    color: 'Red'
  },
  {
    value: 'Cranberry',
    color: 'REd'
  },
  {
    value: 'French Madder',
    color: 'Red'
  },
  {
    value: 'Gabardine: Madder Red',
    color: 'Red'
  },
  {
    value: 'Madder Red',
    color: 'Red'
  },
  {
    value: 'Madder Red Logo',
    color: 'Red'
  },
  {
    value: 'Madder Red Plaid',
    color: 'Red'
  },
  {
    value: 'Madder Red Ram',
    color: 'Red'
  },
  {
    value: 'Madder Red/Blond',
    color: 'Red'
  },
  {
    value: 'Madder Red/Indigo Overdye',
    color: 'Red'
  },
  {
    value: 'Madder/Lead',
    color: 'Red'
  },
  {
    value: 'Raspberry',
    color: 'Red'
  },
  {
    value: 'Red',
    color: 'Red'
  },
  {
    value: 'Red Black Check w/ Black',
    color: 'Red'
  },
  {
    value: 'Red Black Check w/ Black 4 Pack',
    color: 'Red'
  },
  {
    value: 'Red Chambray',
    color: 'Red'
  },
  {
    value: 'Red Floral',
    color: 'Red'
  },
  {
    value: 'Red Logo',
    color: 'Red'
  },
  {
    value: 'Red Ram',
    color: 'Red'
  },
  {
    value: 'Red/Black Check',
    color: 'Red'
  },
  {
    value: 'Red/Black Gingham',
    color: 'Red'
  },
  {
    value: 'Red/Orange/Black',
    color: 'Red'
  },
  {
    value: 'Red/Rose Fish',
    color: 'Red'
  },
  {
    value: 'Red/Rose Frog',
    color: 'Red'
  },
  {
    value: 'Red/Rose Starfish',
    color: 'Red'
  },
  {
    value: 'Rhubarb',
    color: 'Red'
  },
  {
    value: 'Royal Red',
    color: 'Red'
  },
  {
    value: 'Royal Red Logo',
    color: 'Red'
  },
  {
    value: 'Royal Red Ram',
    color: 'Red'
  },
  {
    value: 'Royal Red/Arctic White',
    color: 'Red'
  },
  {
    value: 'Royal Red/Black/White',
    color: 'Red'
  },
  {
    value: 'Royal Red/Sail Navy/Blond',
    color: 'Red'
  },
  {
    value: 'Royal Red/White',
    color: 'Red'
  },
  {
    value: 'Rusty Red',
    color: 'Red'
  },
  {
    value: 'Sunset Red',
    color: 'Red'
  },
  {
    value: 'Beige',
    color: 'Tan'
  },
  {
    value: 'Camel',
    color: 'Tan'
  },
  {
    value: 'Camel/Slate Blue',
    color: 'Tan'
  },
  {
    value: 'Cream',
    color: 'Tan'
  },
  {
    value: 'Heather',
    color: 'Tan'
  },
  {
    value: 'Heather/Espresso',
    color: 'Tan'
  },
  {
    value: 'Herringbone: Espresso/Tan',
    color: 'Tan'
  },
  {
    value: 'Hunter/Tan',
    color: 'Tan'
  },
  {
    value: 'Ivory',
    color: 'Tan'
  },
  {
    value: 'Ivory/Black',
    color: 'Tan'
  },
  {
    value: 'Ivory/Blue Stripe',
    color: 'Tan'
  },
  {
    value: 'Khaki',
    color: 'Tan'
  },
  {
    value: 'Natural',
    color: 'Tan'
  },
  {
    value: 'Neutral',
    color: 'Tan'
  },
  {
    value: 'Pistachio',
    color: 'Tan'
  },
  {
    value: 'Pistachio/Coral',
    color: 'Tan'
  },
  {
    value: 'Pistachio/Goldenrod',
    color: 'Tan'
  },
  {
    value: 'Pistachio/Rock Salt',
    color: 'Tan'
  },
  {
    value: 'Poppy',
    color: 'Tan'
  },
  {
    value: 'Sand',
    color: 'Tan'
  },
  {
    value: 'Tan',
    color: 'Tan'
  },
  {
    value: 'Tan Blue',
    color: 'Tan'
  },
  {
    value: 'Tan Chambray',
    color: 'Tan'
  },
  {
    value: 'Tan Marl',
    color: 'Tan'
  },
  {
    value: 'Taupe',
    color: 'Tan'
  },
  {
    value: 'Taupe/Charcoal',
    color: 'Tan'
  },
  {
    value: 'Taupe/Houndstooth',
    color: 'Tan'
  },
  {
    value: 'Taupe/Midnight',
    color: 'Tan'
  },
  {
    value: 'Taupe/Pewter',
    color: 'Tan'
  },
  {
    value: 'Taupe/Sage',
    color: 'Tan'
  },
  {
    value: 'Taupe/Teal Plaid',
    color: 'Tan'
  },
  {
    value: 'Taupe/Windowpane',
    color: 'Tan'
  },
  {
    value: 'Blond',
    color: 'White'
  },
  {
    value: 'Blond w/Color Stitch',
    color: 'White'
  },
  {
    value: 'Blond/Black',
    color: 'White'
  },
  {
    value: 'Blond/Midnight',
    color: 'White'
  },
  {
    value: 'Blond/Sage/Taupe',
    color: 'White'
  },
  {
    value: 'Gabardine: Black/Blond Twill',
    color: 'White'
  },
  {
    value: 'Herringbone: Black/Blond',
    color: 'White'
  },
  {
    value: 'Herringbone: Blond',
    color: 'White'
  },
  {
    value: 'Natural Blonde',
    color: 'White'
  },
  {
    value: 'New Blue/Blond',
    color: 'White'
  },
  {
    value: 'Sapphire/Blond',
    color: 'White'
  },
  {
    value: 'Taupe/Blond',
    color: 'White'
  },
  {
    value: 'White',
    color: 'White'
  },
  {
    value: 'White Fish',
    color: 'White'
  },
  {
    value: 'White Frog',
    color: 'White'
  },
  {
    value: 'White Logo',
    color: 'White'
  },
  {
    value: 'White Oxford',
    color: 'White'
  },
  {
    value: 'White Ram',
    color: 'White'
  },
  {
    value: 'White Starfish',
    color: 'White'
  },
  {
    value: 'White/Goldenrod',
    color: 'White'
  },
  {
    value: 'White/Grey',
    color: 'White'
  },
  {
    value: 'White/Sail Navy/Royal Red',
    color: 'White'
  },
  {
    value: 'White/Trim',
    color: 'White'
  },
  {
    value: 'Goldenrod',
    color: 'Yellow'
  },
  {
    value: 'Goldenrod Ram',
    color: 'Yellow'
  },
  {
    value: 'Goldenrod/Rock Salt',
    color: 'Yellow'
  },
  {
    value: 'Goldenrod/White',
    color: 'Yellow'
  },
  {
    value: 'Spring Yellow',
    color: 'Yellow'
  },
  {
    value: 'Yellow Blue Check',
    color: 'Yellow'
  },
  {
    value: 'Yellow Plaid',
    color: 'Yellow'
  },
];

const colorSwatches = document.querySelectorAll('[data-color-swatch]');

if (colorSwatches.length != 0) {
  colorSwatches.forEach(swatch => {
    const optionName = swatch.value;
    const found = colorsList.find(data => data.value === optionName);

    if (found) {
      swatch.style.backgroundColor = found.color;
    }
  });
}
